import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export async function getRoomSiteConfigHistory(structureId: string) {
  return Api.get<AdminTypes.SiteConfigHistory[]>(
    `admin/v1/site-configs/${structureId}/history`,
  ).then((res) => res.data);
}
